class reportSrv {

	constructor($resource, SERVICE_URL_CONSTANT) {
		var getReportDynamic = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportDynamic', {}, {
			post: {
				method: 'POST',
			},
		})

		var getReportIntegral = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportIntegral', {}, {
			post: {
				method : 'POST',
				timeout: 180000,
			},
		})

		var getStateApprovalByStage = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getStateApprovalByStage', {}, {
			post: {
				method: 'POST',
			},
		})

		var getReportDataFilters = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportDataFilters', {}, {
			get: {
				method: 'POST',
			},
		})

		var getReportStaticList = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportStaticList', {}, {
			get: {
				method: 'GET',
			},
		})

		var getReportTeachersWorkplan = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportTeachersWorkplan', {}, {
			post: {
				method: 'POST',
			},
		})

		var getReportEvaluators = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportEvaluators', {}, {
			post: {
				method: 'POST',
			},
		})

		var getReportReviewApproved = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportReviewApproved', {}, {
			post: {
				method: 'POST',
			},
		})

		var getReportTeachersActivityUnit = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportTeachersActivityUnit', {}, {
			post: {
				method: 'POST',
			},
		})

		var getSummaryTeachersActivityUnit = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getSummaryTeachersActivityUnit', {}, {
			post: {
				method: 'POST',
			},
		})

		var getReportTeacherActInact = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportTeacherActInact', {}, {
			post: {
				method: 'POST',
			},
		})

		var getReportHoursPlannedExecuted = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportHoursPlannedExecuted', {}, {
			post: {
				method: 'POST',
			},
		})

		var getReportStateWorkplanTeacher = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportStateWorkplanTeacher', {}, {
			post: {
				method: 'POST',
			},
		})

		var getReportStrategicTracking = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportStrategicTracking', {}, {
			post: {
				method: 'POST',
			},
		})

		var getReportObservationWorkplan = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportObservationWorkplan', {}, {
			post: {
				method: 'POST',
			},
		})

		var getReportWorkPlan = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportWorkPlan', {}, {
			post: {
				method: 'POST',
			},
		})

		var getReportFinancial = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportFinancial', {}, {
			post: {
				method: 'POST',
			},
		})

		var getReportStatic = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportStatic', {}, {
			post: {
				method: 'POST',
			},
		})

		var getReportTeacherSpecialSituation = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportTeacherSpecialSituation', {}, {
			post: {
				method: 'POST',
			},
		})

		var addDynamicReport = $resource(SERVICE_URL_CONSTANT.rosario + '/report/addDynamicReport', {}, {
			post: {
				method: 'POST',
			},
		})

		var listDynamicReport = $resource(SERVICE_URL_CONSTANT.rosario + '/report/listDynamicReport', {}, {
			post: {
				method: 'POST',
			},
		})

		var getDynamicReportDetail = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getDynamicReportDetail', {}, {
			post: {
				method: 'POST',
			},
		})

		var deleteDynamicReport = $resource(SERVICE_URL_CONSTANT.rosario + '/report/deleteDynamicReport', {}, {
			post: {
				method: 'POST',
			},
		})

		var SaveReportData = $resource(SERVICE_URL_CONSTANT.rosario + '/report/addReportList', {}, {
			post: {
				method: 'POST',
			},
		})

		var ValidNameReport = $resource(SERVICE_URL_CONSTANT.rosario + '/report/ValidNameReportList', {}, {
			post: {
				method: 'POST',
			},
		})

		var getReportData = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportList', {}, {
			get: {
				method: 'GET',
			},
		})

		var getReportTimestamp = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getTimestamp', {}, {
			get: {
				method: 'GET',
			},
		})

		var getFilePath = function (filename) {
			return SERVICE_URL_CONSTANT.rosario + '/report/getFile/' + filename 
		}
		const checkFileReady = $resource(SERVICE_URL_CONSTANT.rosario + '/report/checkFileReady', {}, {
			get: {
				method: 'GET',
			},
		})

		return {
			getReportDynamic                : getReportDynamic,
			getReportIntegral               : getReportIntegral,
			getStateApprovalByStage         : getStateApprovalByStage,
			getReportDataFilters            : getReportDataFilters,
			getReportTeachersWorkplan       : getReportTeachersWorkplan,
			getFilePath                     : getFilePath,
			getReportEvaluators             : getReportEvaluators,
			getReportTeacherSpecialSituation: getReportTeacherSpecialSituation,
			getReportReviewApproved         : getReportReviewApproved,
			getReportTeachersActivityUnit   : getReportTeachersActivityUnit,
			getSummaryTeachersActivityUnit  : getSummaryTeachersActivityUnit,
			getReportTeacherActInact        : getReportTeacherActInact,
			getReportHoursPlannedExecuted   : getReportHoursPlannedExecuted,
			getReportWorkPlan               : getReportWorkPlan,
			addDynamicReport                : addDynamicReport,
			listDynamicReport               : listDynamicReport,
			getDynamicReportDetail          : getDynamicReportDetail,
			deleteDynamicReport             : deleteDynamicReport,
			SaveReportData                  : SaveReportData,
			ValidNameReport                 : ValidNameReport,
			getReportData                   : getReportData,
			getReportTimestamp              : getReportTimestamp,
			getReportStateWorkplanTeacher   : getReportStateWorkplanTeacher,
			getReportStrategicTracking      : getReportStrategicTracking,
			getReportObservationWorkplan    : getReportObservationWorkplan,
			getReportStaticList             : getReportStaticList,
			getReportFinancial              : getReportFinancial,
			checkFileReady,

		}
	}

}

reportSrv.$inject = [ '$resource', 'SERVICE_URL_CONSTANT' ]
export default angular.module('services.reportSrv', [])
	.service('reportSrv', reportSrv)
	.name


// WEBPACK FOOTER //
// ./src/app/u-faculty/report/reportSrv.js